module.exports = __webpack_public_path__ + "static/media/layers-simple-fill.07ac5383.svg";